import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { ConnectionType } from "@common/ADAPT.Common.Model/organisation/connection-type";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { AddPeopleDialogComponent } from "app/organisation/user-management/add-people-dialog/add-people-dialog.component";

@Component({
    selector: "adapt-employee-directory-page",
    templateUrl: "./employee-directory-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EmployeeDirectoryPageComponent extends BaseRoutedComponent implements OnInit {
    public constructor(
        private dialogService: AdaptCommonDialogService,
        injector: Injector,
    ) {
        super(injector);
    }

    public inviteUser = () => this.dialogService.open(AddPeopleDialogComponent, { connectionType: ConnectionType.Employee });

    public ngOnInit() {
        this.notifyActivated();
    }
}
